/**
 * Table Manager
 * Serve per poter leggere e parsare i dati html in jsp. le customizzazioni vanno applicati ad una dashboard
 */
hrd.manager.TableManager = hrd.AbstractCommonInterface.extend({
	tableInstance: undefined,
	selectedIndexes: undefined,
	selectedObjects: undefined,
	init: function(container, options) {
		var defaults = {
			impl: 'hrd.manager.TableManager',
			insideDashlet: true,
			rowPrefix: undefined,
			tableId: '',
			reference: undefined,
			refreshOnResize: true,
			keepSelectionOnRefresh: false
		};
		this.uuid = parseInt(Math.random() * 10000);
		this.selectedIndexes = [];
		this.selectedObjects = {};
		this._super($.extend({}, defaults, options));
		this.container = $(container);
		this.settings.rowPrefix = this.settings.rowPrefix || $.camelCase(this.settings.prefix);
		this.settings.tableId = this._toIdSelector('table');
		this.toolbox = new hrd.Toolbox();
		if (!$(this.settings.tableId).exists()) {
			var $table = (this.settings.insideDashlet) ? this.container.find('.dashlet-table') : this.container.find('table');
			$table.attr('id', this._toId('table')).addClass('data-table');
		}
		if (this.settings.reference instanceof hrd.AbstractTableDashlet) {
			this.settings.reference.TABLE_ID = this.settings.tableId; // need to be here because not evaluated when opening table dialog the second time
		}
	},
	doTable: function() {
		var reference = this.settings.reference;
		var refSettings = reference.settings;

		if (refSettings.style && refSettings.style.indexOf('reverse') != -1) {
			$(this.settings.tableId).addClass('reverse')
		}

		if (reference.settings.size == '2x') {
			$(this.settings.tableId).addClass('table-2x')
		}

		var canDestroyTable = this.tableOptions == undefined ? false : !!this.tableOptions.bDestroy;
		if (this.tableInstance == undefined || canDestroyTable) {
			return this.createTable().then(function(tableInstance) {
				this.tableInstance = tableInstance;
				this.doPostInited();
				return $.when(tableInstance);
			}.bind(this));
		} else {
			return $.when(this.tableInstance);
		}
	},
	isInitialized: function() {
		var $thisTable = $(this.settings.tableId);
		if ($thisTable.exists()) {
			return $.fn.DataTable.fnIsDataTable($thisTable.get(0));
		} else {
			return false;
		}
	},
	createTable: function() {
		let deferred = $.Deferred();
		let $table = $(this.settings.tableId);
		let tableOptions = this.doTableOptions();
		let reference = this.settings.reference;
		
		tableOptions.fnInitComplete = function(oSettings, json) {
			deferred.resolve(this); // here 'this' is tableInstance' and not 'tableDashlet'
		};
		/* registering for 'xhr' event for table footer - here can be addedd methods for managing other stuff after ajax call before table rendering */
		$table.on('xhr', function(event, tableSettings, tableData) {
			if (tableData.footer) {
				tableSettings.oFooter = tableData.footer;
			} else {
				tableSettings.oFooter = undefined;
			}
		});
		/* 'table-2x' : add it to Info classes */
		if (reference.settings.size == '2x') {
			tableOptions.sInfoCls += ' table-2x';
		}
		
		if(typeof reference['postProcessTableOptions'] === 'function') {
			// da estendere per casi multi-tabella
			let fn = reference['postProcessTableOptions'];
			tableOptions = fn.call(reference, tableOptions);
		}
		
		this.tableOptions = tableOptions;
		$table.dataTable(tableOptions);
		// fix in order to have 'tableIntance' variable available as soon as possible (usable in fnDrawCallback). promise will return too late
		reference.tableInstance = $table;
		//

		return deferred.promise();
	},
	manageFeature: function(sFeatureName) {
		let ref = this.settings.reference;
		let fn = (typeof ref[sFeatureName] === 'function') ? ref[sFeatureName] : undefined;
		let tableName = this.container.data('name');
		if (tableName != undefined) {
			let sFn = $.functionCase(`${sFeatureName}-for-${tableName}`);
			if (typeof ref[sFn] === 'function') {
				fn = ref[sFn];
			} else {
				if (fn != undefined) {
					console.info(`It is possible to use "${sFn}" in place of "${sFeatureName}" as method in ${ref._FULL_}`);
				}
			}
		}
		return (fn != undefined) ? fn.bind(ref) : undefined;	
	},
	getTableInfo: function() {
		return $(this.settings.tableId).data('table-info');
	},
	doTableOptions: function() {
		var ref = this.settings.reference,
			tableId = this.settings.tableId,
			thisManager = this;

		// search for proper doTableOptions method
		let fnDoTableOptions = ref['doTableOptions'];
		let tableName = this.container.data('name');
		if (tableName != undefined) {
			let sFnDoTableOptions = $.functionCase(`do-${tableName}-table-options`);
			if (typeof ref[sFnDoTableOptions] === 'function') {
				fnDoTableOptions = ref[sFnDoTableOptions];
			} else {
				if (sFnDoTableOptions != undefined) {
					console.info(`It is possible to use "${sFnDoTableOptions}" in place of "doTableOptions" as method to specify additional parameters in ${ref._FULL_}`);
				}
			}
		}

		if (typeof fnDoTableOptions !== 'function') {
			console.error(`"doTableOptions" is missing in "${ref._FULL_}"`);
		}

		var opts = fnDoTableOptions.call(ref);
		var docLabel, filterLabel, options;

		if (opts.options != undefined) {
			docLabel = opts.docLabel;
			filterLabel = opts.filterLabel;
			options = opts.options;
		} else {
			docLabel = opts.docLabel;
			filterLabel = opts.filterLabel;
			options = opts;
		}

		var infoTable = $(tableId).data('table');
		var info = $.evaluate(infoTable, ref);
		$(tableId).data('table-info', info);
		if (info.rowPrefix) {
			this.settings.rowPrefix = info.rowPrefix;
		}
		var columns;
		var initialSorting = [];
		columns = this.autoColumns(initialSorting, info);
		
		// detect if the table has a non generic check column, if so it is multi-selectable
		let isMultiSelectTable = columns.filter(column => (column.type === 'check' && !column.isGeneric)).length > 0;
		this.settings.isMultiSelectTable = isMultiSelectTable;
		//post processing for multi-column sorting
		var cNames = $.map(columns, c => (c.sName || c.mData));
		$.each(columns, (i, c) => {
			if (c.aDataSort) {
				$.each(c.aDataSort, (j, v) => {
					if (typeof v == 'string') {
						c.aDataSort[j] = cNames.indexOf(v);
					}
				})
			}
		});

		var sContainerId = (options.sScrollY != undefined) ? undefined : $(ref.CONTENT_ID).exists() ? ref.CONTENT_ID : $(ref.PANEL_ID).exists() ? ref.PANEL_ID : this.container.attr('id');

		if (!(this.settings.insideDashlet) && options.sScrollY == undefined) {
			if (options.useFieldCompositeAsContainer) {
				sContainerId = '#' + $(tableId).closest('*[data-type="table"]').parent().uniqueId().attr('id');
			} else {
				sContainerId = '#' + $(tableId).closest('*[data-type="table"]').attr('id');
			}
		}

		var defaults = {
			'sContainerId': sContainerId,
			'fnRowCallback': function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
				let ref = this.settings.reference;
				//let fnClick = (typeof ref.clickRow === 'function') ? ref.clickRow.bind(ref) : undefined;
				let fnClick = this.manageFeature('clickRow');
				//let fnDblClick = (typeof ref.dblClickRow === 'function') ? ref.dblClickRow.bind(ref) : undefined;
				let fnDblClick = this.manageFeature('dblClickRow');
				let fnChange = (isMultiSelectTable) ? function(nRow, aData, iDisplayIndex, iDisplayIndexFull, checked, value, event) {
					if (checked) {
						this.addSelection(value, aData);
					} else {
						this.removeSelection(value);
					}
					this.onSelectionChange(nRow, aData, iDisplayIndex, iDisplayIndexFull, checked, value, event);
				}.bind(this) : undefined;
//				let fnOver = (typeof ref.overRow === 'function') ? ref.overRow.bind(ref) : undefined;
				let fnOver = this.manageFeature('overRow');
//				let fnOut = (typeof ref.outRow === 'function') ? ref.outRow.bind(ref) : undefined;
				let fnOut = this.manageFeature('outRow');
				let fnCellOver = this.manageFeature('overCell');
				let fnCellOut = this.manageFeature('outCell');
				if (typeof ref.dragRow === 'function') {
					ref.dragRow(nRow, aData, iDisplayIndex, iDisplayIndexFull);
				}
				if (typeof ref.dropRow === 'function') {
					ref.dropRow(nRow, aData, iDisplayIndex, iDisplayIndexFull);
				}
				if (typeof ref.rowCreated === 'function') {
					ref.rowCreated(nRow, aData, iDisplayIndex, iDisplayIndexFull);
				}
				hrd.datatable.rowBehavior(tableId, nRow, aData, iDisplayIndex, iDisplayIndexFull, fnClick, fnDblClick, fnChange, fnOver, fnOut, fnCellOver, fnCellOut);
			}.bind(this)
		};
		var basicSettings = hrd.datatable.dtSettings(docLabel, filterLabel);

		var tableOptions = $.extend({}, basicSettings, defaults, options);

		if (tableOptions.ignoreAjaxSource) {
			delete tableOptions.sAjaxSource;
		}

		tableOptions.oScroller = $.extend({}, basicSettings.oScroller, options.oScroller);
		tableOptions.oLanguage = $.extend({}, basicSettings.oLanguage, options.oLanguage);

		if (info.footer == true) {
			this.autoFooter();
			/* registering footerCallback function */
			tableOptions.fnFooterCallback = function(nFoot, aData, iStart, iEnd, aiDisplay) {
				var oFooter = $(this).dataTable().fnSettings().oFooter;

				if (typeof tableOptions.fnCustomFooterCallback === 'function') {
					tableOptions.fnCustomFooterCallback.call(ref, nFoot, aData, iStart, iEnd, aiDisplay);
				}

				if (info.footerSize == 2) {
					var parentFooter = $(nFoot).parent();
					var nFoot2;
					if (parentFooter.children().size() != 2) {
						// need to create second footer row
						nFoot2 = $(nFoot).clone();
						parentFooter.append(nFoot2);
					} else {
						// need to reference second footer row
						nFoot2 = parentFooter.children().last();
					}
					$('*[data-ref]', nFoot).each((i, fc) => {
						var $fc = $(fc);
						var dataRef = $fc.data('ref');
						var property = dataRef[0];
						var value = oFooter ? oFooter[property] : '';
						thisManager.formatFooterCellValue(property, value, $fc);
					});
					$('*[data-ref]', nFoot2).each((i, fc) => {
						var $fc = $(fc);
						var dataRef = $fc.data('ref');
						var property = dataRef[1];
						var value = oFooter ? oFooter[property] : '';
						thisManager.formatFooterCellValue(property, value, $fc);
					});
				} else {
					$('*[data-ref]', nFoot).each((i, fc) => {
						var $fc = $(fc);
						var property = $fc.data('ref');
						var value = oFooter ? oFooter[property] : '';
						thisManager.formatFooterCellValue(property, value, $fc);
					});
				}
			}
		}
		tableOptions.aoColumns = columns;
		if (tableOptions.aaSorting === undefined) {
			tableOptions.aaSorting = initialSorting;
			tableOptions.aaInitialSorting = JSON.parse(JSON.stringify(initialSorting));
		} else {
			if (initialSorting.length > 0) {
				console.log('Initial sorting already defined in custom options. Ignored the column definitions: ', initialSorting);
			}
		}
		
		let thisReference = ref;
		tableOptions.fnServerParams = function(aoData) {
			// HERE "this" is the dataTable reference, but sometimes it cannot be available
			let oSettings = (typeof this.fnSettings === 'function') ? this.fnSettings() : undefined;
			
			if (typeof info.providerFn == 'function') {
				info.provider = info.providerFn.call(thisReference);
			}
			if(info.provider) {
				aoData.push({ "name": "sProvider", "value": info.provider });
			}
			// search for proper ServerParams method
			let fnServerParams = thisReference['getServerParams'];
			let tableName = thisManager.container.data('name');
			if (tableName != undefined) {
				let sFnServerParams = $.functionCase(`get-${tableName}-server-params`);
				if (typeof thisReference[sFnServerParams] === 'function') {
					fnServerParams = thisReference[sFnServerParams];
				} else {
					if (fnServerParams != undefined) {
						console.info(`It is possible to use "${sFnServerParams}" in place of "getServerParams" as method to specify additional parameters in ${thisReference._FULL_}`);
					}
				}
			}
			if (fnServerParams != undefined) {
				var params = fnServerParams.call(thisReference);
				if (params != undefined && typeof params === 'object') {
					for (var key in params) {
						if ($.isArray(params[key])) {
							$.each(params[key], function(i, p) {
								aoData.push({ "name": key, "value": p });
							});
						} else {
							aoData.push({ "name": key, "value": params[key] });
						}
					}
				}
			}
			
			/* Sorting: adding some custom attributes */
			let bSort = thisReference.toolbox.get('oFeatures.bSort', oSettings, false);
			if (bSort) {
				let aaSort = (oSettings.aaSortingFixed !== null) ?
					oSettings.aaSortingFixed.concat(oSettings.aaSorting) :
					oSettings.aaSorting.slice();

				for (i = 0; i < aaSort.length; i++) {
					let bCustomSorting = oSettings.aoColumns[aaSort[i][0]].bCustomSorting;
					if(bCustomSorting) {
						aoData.push({ "name": "bCustomSortCol_0", "value": bCustomSorting });
					}
				}
			}
		};
		
		if (typeof tableOptions.fnReady !== 'function') {
			tableOptions.fnReady = function(oSettings, aoData) {
				let pageSizeParam = aoData.find(data => data.name === 'iPageSize');
				//let providerParam = aoData.find(data => data.name === 'sProvider') || {};
				let iPageSize = pageSizeParam == undefined ? -1 : pageSizeParam.value;
				// la 'prima' chiamata con ajax sembra avere iDraw == 2, 
				// se ipageSize == 0 ed è la prima chiamata, obbliga ad un ricalcolo successivo per dar tempo alla tabella di ridimensionarsi
				// let isNotReady = iPageSize == 0 && oSettings.iDraw == 2;
				// per ora riprovo finche ipageSize == 0 e iDraw < 10, per evitare loop infiniti
				let isNotReady = iPageSize == 0 && oSettings.iDraw < 10;
				oSettings.ignoreFirstCall = isNotReady;
				//console.log('fnReady', iPageSize, isNotReady , providerParam.value);
				return !isNotReady;
			}
		}

		/* registering my 'fnServerData' implementation if not already overridden */
		if (tableOptions.fnServerData === undefined) {
			tableOptions.fnServerData = function(sSource, aoData, fnCallback, oSettings) {
				let isReady = tableOptions.fnReady.call(ref, oSettings, aoData);
				if (!isReady) {
					let emptyTable = {
						iTotalDisplayRecords: 0,
						iTotalRecords: 0,
						aaData: []
					};
					fnCallback(emptyTable);
				} else if (oSettings.useCache && oSettings.jCachedData) {
					oSettings.useCache = undefined;
					oSettings.jCachedData.sEcho = `${oSettings.iDraw}`; // needed to avoid data to be ignored
					$.broadcast($(oSettings.oInstance), 'xhr', oSettings, oSettings.jCachedData)
						.then(() => fnCallback(oSettings.jCachedData));
				} else if(info.useLocalProvider === true) {
					// search for proper LocalProvider method
					let fnLocalProvider = ref['localProvider'];
					let sLocalProvider;
					let tableName = this.container.data('name');
					if (tableName != undefined) {
						sLocalProvider = $.functionCase(`${tableName}-local-provider`);
						if (typeof ref[sLocalProvider] === 'function') {
							fnLocalProvider = ref[sLocalProvider];
						}
					}
					if (fnLocalProvider == undefined) {
						if(sLocalProvider == undefined) {
							console.info(`Add method "localProvider: function(tableSettings) {}," to implement a LocalProvider in ${ref._FULL_}`);
						} else {
							console.info(`Add method "${sLocalProvider}: function(tableSettings) {}," to implement a LocalProvider in ${ref._FULL_}`);
						}
						fnCallback(this.adaptForTable());
					} else {
						$.when(fnLocalProvider.call(ref, oSettings)).then((json) => {
							json = json || {};
							json = this.adaptForTable(json);
							fnCallback(json);
						});
					}
				} else {
					var prv = info.provider ? info.provider.substring(info.provider.lastIndexOf('.') + 1) : undefined;
					let settings = {
						'url': sSource + (prv ? '?_=' + prv : ''),
						'data': aoData,
						'dataType': "json",
						'cache': false,
						'type': prv ? 'POST' : oSettings.sServerMethod
					};
					if (hrd.globals.apiKey != undefined) {
						settings.headers = {
							"Api-Key": hrd.globals.apiKey
						};
					}
					if (hrd.globals.apiKeyExt != undefined) {
						settings.headers = {
							"Api-Key-Ext": hrd.globals.apiKeyExt
						};
					}
					if (hrd.globals.apiKeyUser != undefined) {
						settings.headers = {
							"Api-Key-User": hrd.globals.apiKeyUser
						};
					}
					let startCall = moment();
					oSettings.jqXHR = $.ajax(settings);
					oSettings.jqXHR
						.then(function(json) {
							let endCall = moment();
							if (json && json.sError) {
								oSettings.oApi._fnLog(oSettings, 0, json.sError);
							}
							let callDuration = moment.duration(endCall.diff(startCall));
							json._duration_ = callDuration.asMilliseconds();
							$.broadcast($(oSettings.oInstance), 'xhr', oSettings, json).then(function() {
								oSettings.jCachedData = json;
								fnCallback(json);
							});
						})
						.fail(function(xhr, error, thrown) {
							if (error == "parsererror") {
								oSettings.oApi._fnLog(oSettings, 0, "DataTables warning: JSON data from " +
									"server could not be parsed. This is caused by a JSON formatting error.");
							}
						})
				}
			}.bind(this);
		}
		/* fnCustomDrawCallback */
		var customizedDrawCallback = $.noop;
		if (typeof tableOptions.fnCustomDrawCallback === 'function') {
			customizedDrawCallback = tableOptions.fnCustomDrawCallback;
		}
		tableOptions.fnCustomDrawCallback = function(oSettings) {
			if (this.settings.keepSelectionOnRefresh) {
				this.selectTableRows(this.getSelectedIndexes(), this.settings.triggerOnRefresh);
			}
			customizedDrawCallback.call(ref, oSettings);
			$(this.settings.tableId).trigger('table-draw-complete');
		}.bind(this);
		/* -------------------- */
		return tableOptions;
	},
	adaptForTable: function(json) {
		let table;
		if (json == undefined || !$.isArray(json.aData)) {
			table = {
				iTotalDisplayRecords: 0,
				iTotalRecords: 0,
				aaData: []
			};
		} else {
			/* TODO: expand to support footers and other features */
			table = {
				iTotalDisplayRecords: json.aData.length,
				iTotalRecords: json.aData.length,
				aaData: json.aData
			};
		}
		return table;
	},
	updateFooterCell: function(property, value) {
		let oSettings = this.tableInstance.fnSettings();
		let nFoot = oSettings.nTFoot;
		$('*[data-ref]', nFoot)
			.filter((i, fc) => $(fc).data('ref') === property)
			.each((i, fc) => this.formatFooterCellValue(property, value, $(fc)));
	},
	formatFooterCellValue: function(property, value, $fc) {
		var ref = this.settings.reference;
		var fcOptions = $fc.data('options') || {};
		$fc.addClass(property);
		var cellData = hrd.datatable.formatCellData.call(ref, value, fcOptions.style, fcOptions);
		$fc.children('.table_cell_content').html(cellData);
	},
	testProvider: function() {
		var options = this.doTableOptions();
		var params = [];
		params.push({ name: 'sizeOnly', value: 'true' });
		options.fnServerParams(params);
		var info = $(this.settings.tableId).data('table-info');
		var source = options.sAjaxSource;
		if (info != undefined) {
			var prv = info.provider ? info.provider.substring(info.provider.lastIndexOf('.') + 1) : undefined;
			source += (prv ? '?_=' + prv : '');
		}
		return $.ajax({
			'url': source,
			'data': params,
			'dataType': "json",
			'cache': false,
			'type': 'POST'
		}).then(data => $.when(data));
	},
	fnSettings: function() {
		if (this.tableInstance != undefined) {
			return this.tableInstance.fnSettings();
		} else {
			return $(this.settings.tableId).dataTable().fnSettings();
		}
	},
	doPostInited: function() {
		var info = $(this.settings.tableId).data('table-info');
		if (info && info.editable === true) {
			var editableOptions = this.doEditableOptions();
			this.tableInstance.makeEditable(editableOptions);
			// autofill can be used only for editable tables;
			if (info.autofill === true && !$('body').hasClass('ipad')) {
				var opts = this.doAutoFillOptions(editableOptions);
				new $.fn.dataTable.AutoFill(this.tableInstance, opts);
			}
			// if table has been already populated, i just need to standing refresh the table data. this can happen in tables in hidden tabs
			if (this.tableInstance.fnSettings().aoData.length !== 0) {
				this.tableInstance.fnStandingRedraw();
			}
		}
		if (info && info.alternate == true) {
			$(this.settings.tableId).addClass('use-alternate-rows');
		}

		if (info && info.hideHeader == true) {
			var tableSettings = this.tableInstance.fnSettings();
			var $dtHead = $(tableSettings.nScrollHead);
			$dtHead.hide();
		}
	},
	doEditableOptions: function() {
		var opts = this.settings.reference.doEditableOptions();
		opts = opts || {};
		var tableSettings = this.tableInstance.fnSettings();
		var settings = {
			'sUpdateURL': hrd.globals.jsondataURI,
		};
		var columns = [];
		$.each(tableSettings.aoHeader[0], function(index, hi) {
			var $th = $(hi.cell);
			var info = $th.data('col-info');
			if (info) {
				switch (info.editable) {
					case 'text':
					case 'integer':
					case 'real':
					case 'duration':
						var colData = { event: 'click', type: info.editable, cssclass: 'editable-table-inline' + (info.nullable === true ? ' nullable' : ''), select: true };
						if (info.ref != undefined) {
							colData.name = info.ref;
							colData.alias = info.prop;
						} else {
							colData.name = info.prop;
						}
						if (info.pattern) {
							colData.pattern = info.pattern;
						}
						if (info.editableOptions) {
							colData.editableOptions = info.editableOptions;
						}
						if (info.inlineEditableOptions) {
							colData = $.extend(colData, info.inlineEditableOptions);
						}
						columns.push(colData)
						break;
					case 'select':
						var adapter = info.selectAdapter ? info.selectAdapter : hrd.datatable.selectAdapter;
						var colData = { event: 'click', name: info.ref, alias: info.prop, type: info.editable, cssclass: 'editable-table-inline', onchange: 'submit', selectAdapter: adapter, loadurl: hrd.globals.datatableURI, loaddata: info.loaddata };
						if (info.editableOptions) {
							colData.editableOptions = info.editableOptions;
						}
						if (info.inlineEditableOptions) {
							colData = $.extend(colData, info.inlineEditableOptions);
						}
						columns.push(colData)
						break;
					default:
						columns.push(null);
						break;
				}
			}
		}.bind(this));
		opts.aoColumns = columns;
		return $.extend({}, settings, opts);
	},
	doAutoFillOptions: function(editableOptions) {
		var reference = this.settings.reference;
		var opts = reference.doAutoFillOptions.call(reference, {}, editableOptions);
		opts = opts || {};
		var tableSettings = this.tableInstance.fnSettings();
		var settings = {
			'mode': 'y',
			'complete': function(aoEdited) {
				var promises = $.map(aoEdited, function(edited, index) {
					if (edited.oldValue != edited.newValue) {
						var colName = this.tableInstance.fnGetColumnNameByIndex(edited.colIdx);
						var rowData = this.tableInstance.fnGetData($(edited.cell.node).parent().get(0))

						var cellEditInfo = editableOptions.aoColumns[edited.cell.colIdx];
						var newValue;
						switch (cellEditInfo.type) {
							case 'duration':
								var pattern = (typeof cellEditInfo.pattern == 'function') ? cellEditInfo.pattern() : (cellEditInfo.pattern || 'hh:mm');
								var pivot = (pattern == 'hh:mm') ? 'minutes' : (pattern == 'mm:ss') ? 'seconds' : 'minutes';
								var tmpVal = edited.newValue;
								if (tmpVal == '') {
									newValue = 0;
								} else {
									tmpVal = tmpVal.replace(/[\s]/gi, '').replace(/[,\.]/gi, ':');
									var duration;
									if (tmpVal.indexOf(':') == -1) {
										// only numbers (?), should be treated as 'minutes' or 'seconds'
										duration = moment.duration(parseInt(tmpVal), pivot);
									} else {
										// if 'minutes' then hh:mm is ok as pattern for moment. if 'seconds' then a '0:' should be added so that it can be treated as duration with 0 hours
										duration = (pivot == 'minutes') ? moment.duration(tmpVal) : moment.duration('0:' + tmpVal);
									}
									newValue = duration.asSeconds();
								}
								break;
							default:
								newValue = edited.newValue;
								break;
						}

						var data = editableOptions.fnCustomUpdateData(rowData);
						data.columnName = colName;
						data[colName] = newValue;
						var ajaxOptions = {
							url: editableOptions.sUpdateURL,
							dataType: "json",
							data: data
						};
						return $.ajax(ajaxOptions).then(function(response, status, xhr) {
							return $.when(response);
						})
					} else {
						return $.when();
					}
				}.bind(this));
				return $.when.all(promises).then(function() {
					if (typeof opts.onComplete == 'function') {
						return opts.onComplete.call(reference);
					}
				}.bind(this))
			}.bind(this)
		};
		var columns = [];
		$.each(tableSettings.aoHeader[0], function(index, hi) {
			var $th = $(hi.cell);
			var info = $th.data('col-info');
			// solo le colonne editabili avranno la proprietà!!!! skippando le select
			if (info.editable && info.editable != 'select' && !(info.autofill == false)) {
				columns.push({
					bEnable: true,
					"fnRead": function(nTd) {
						var $label = $('label', nTd);
						var $ignore = $('.ignore', $label);
						if ($ignore.exists()) {
							$ignore.remove();
						}
						return $label.text().trim();
					},
					"fnStep": function(cell, read, last, i, x, y) {
						return last === undefined ? read : last;
					},
					"fnWrite": function(nTd, sValue, isLast) {
						return $('label', nTd).text(sValue);
					}
				});
			} else {
				columns.push({ bEnable: false });
			}
		}.bind(this));
		opts.aoColumns = columns;
		return $.extend({}, settings, opts);
	},
	autoColumns: function(initialSorting, tableInfo) {
		var ref = this.settings.reference,
			tableId = this.settings.tableId;
		var columns = [];
		let skipScrollbarColumn = ($.getScrollbarWidth() > 0) || !!tableInfo.skipScrollbarColumn;
		if(!skipScrollbarColumn) {
			let tHeader = $('thead > tr', tableId);
			let sbCol = tHeader.find('th.scrollbar-col');
			if(!sbCol.exists()) {
				tHeader.append(`<th class="scrollbar-col" data-col="{type:'scollbar-ph', sWidth: '6'}" style="max-width:6px; min-width: 6px;"></th>`)
			}
		}
		
		$('thead > tr > th', tableId).each(function(index, th) {
			var $th = $(th);
			var dataCol = $th.data('col');
			var info = $.isPlainObject(dataCol) ? dataCol : $.evaluate($th.data('col'), ref);
			$th.addClass('table_header_center').data('col-info', info);
			if (info.headerMarker) {
				$th.addClass(info.headerMarker);
			}
			// define initial sorting
			if (info.sort) {
				initialSorting.push([index, info.sort]);
			}
			//
			var column;
			switch (info.type) {
				case 'radio':
					$th.addClass('with-icon');
					if (!info.visible) {
						$th.hide();
					}
					column = this.createRadioColumn(info);
					break;
				case 'check':
					if (!info.isGeneric) {
						$th.addClass('with-icon');
					}
					if (info.visible === false) {
						$th.hide();
					}
					if (info.toggleAll != undefined) {
						var $cb = $(('<input type="checkbox" class="toggle-all" data-ignore="true">'));
						$cb.on('click', event => {
							var active = $cb.prop('checked') && !event.shiftKey;
							this.onToggleAll(active);
						});
						if (info.showToggleAllTooltip) {
							$cb.on('mouseover', event => {
								var size = this.getSelectedIndexes().length;
								var tooltip = (size != 0) ? xlate('common.datatable.toggleAll.selection.tooltip', { selected: size }) : xlate('common.datatable.toggleAll.selectionEmpty.tooltip');
								$cb.attr('title', tooltip).tooltip();
							});
						}
						$th.append($cb);
						this.$toggleAllElement = $cb;
					}
					if (!info.isGeneric) {
						// change value of keepSelectionOnRefresh settings to true, because exists a checkboxColumn
						this.settings.keepSelectionOnRefresh = true;
						this.settings.triggerOnRefresh = info.triggerOnRefresh;
					} else {
						let events = info.events ? info.events.split(' ') : [];
						events.forEach(ev => {
							let fnName = $.functionCase(`${info.prop}-on-${ev}`);
							if (ref && typeof ref[fnName] === 'function') {
								info[fnName] = ref[fnName];
							} else {
								var target = (ref && ref._FULL_) ? ref._FULL_ : 'unknown';
								console.log(`Add "${fnName}: function(evt, field, isChecked, nTd, oData, iRow, iCol) {}" to proper object reference "${target}"`);
							}
						});
					}
					column = this.createCheckboxColumn(info);
					break;
				case 'action':
					if (!info.showHeader) {
						$th.addClass('with-icon').text('');
					} else {
						// force witdh to contain header label only
						var w = $.textMetrics($th.text(), 'dataTables_header_length_evaluator').width;
						info.sWidth = w + 'px';
					}
					column = this.createButtonColumn(info.action, info);
					break;
				case 'icon':
					info.tooltip = $th.text();
					if (!info.showHeader) {
						$th.addClass('with-icon').text('');
					} else {
						// force witdh to contain header label only
						var w = $.textMetrics($th.text(), 'dataTables_header_length_evaluator').width;
						info.sWidth = w + 'px';
					}
					column = this.createIconColumn(info.prop, info);
					break;
				case 'booleanIcon':
					info.tooltip = info.tooltip || $th.text();
					if (!info.showHeader) {
						$th.addClass('with-icon').text('');
					} else {
						if (!info.forceWidth) {
							// force witdh to contain header label only
							var w = $.textMetrics($th.text(), 'dataTables_header_length_evaluator').width;
							info.sWidth = w + 'px';
						}
					}
					column = this.createBooleanIconColumn(info.prop, info);
					break;
				case 'color':
					if (!info.showHeader) {
						$th.addClass('with-icon').text('');
					} else {
						// force witdh to contain header label only
						var w = $.textMetrics($th.text(), 'dataTables_header_length_evaluator').width;
						info.sWidth = w + 'px';
					}
					column = this.createColoredColumn(info.prop, info);
					break;
				case 'lLabel':
					info.align = 'left';
					column = this.createLabelColumn(info.prop, info);
					break;
				case 'cLabel':
					info.align = 'center';
					column = this.createLabelColumn(info.prop, info);
					break;
				case 'rLabel':
					info.align = 'right';
					column = this.createLabelColumn(info.prop, info);
					break;
				case 'duration': {
					info.align = 'center';
					column = this.createLabelColumn(info.prop, info);
					break;
				}
				case 'image': {
					info.align = 'center';
					column = this.createImageColumn(info.prop, info);
					break;
				}
				case 'file': {
					info.align = 'center';
					column = this.createFileColumn(info.prop, info);
					break;
				}
				case 'customTemplate': {
					column = this.createCustomColumn(info);
					break;
				}
				case 'input': {
					column = this.createInputColumn(info);
					break;
				}
				case 'select': {
					column = this.createSelectColumn(info.prop, info);
					break;
				}
				case 'empty': {
					column = this.createEmtpyColumn(info);
					break;
				}
				case 'scollbar-ph': {
					info.sName = 'scroll-bar-placeholder';
					column = this.createScrollbarPlaceholderColumn(info);
					break;
				}
				default:
					break;
			}
			if (info.aDataSort) {
				column.aDataSort = [index].concat(info.aDataSort);
			}
			this.adaptSWidth(column);
			columns.push(column);
		}.bind(this));
		return columns;
	},
	adaptSWidth: function(column) {
		let sWidth = column.sWidth;
		if(sWidth != undefined) {
			let isPercentage = (typeof sWidth == 'string') && (sWidth.endsWith('%'));
			if(!isPercentage) {
				nWidth = parseFloat(sWidth)
				if(dashboardInstance.usingChromaFlow()) {
					nWidth =  dashboardInstance.adaptSize(nWidth, {decimalPrecision: 0});
				}
				column.sWidth = `${nWidth}px`;
			}
		} else {
			// store that this column does not have a declared 'sWidth'
			column.sWidthMissing = true;
		}
	},
	autoFooter: function() {
		let $footer = $('<tfoot></tfoot>');
		let $footerRow = $('<tr></tr>');
		$(this.settings.tableId).append($footer);
		$footer.append($footerRow);

		let colspanBuffer = 0
		$('thead > tr > th', this.settings.tableId)
			.toArray()
			.map(th => $(th).data('col-info'))
			.forEach(info => {
				let $fc = $('<th></th>');
				if (info.type == 'radio') {
					$fc.hide();
				}
				if (info.footer) {
					let align = info.type == 'lLabel' ? 'left' : info.type == 'rLabel' ? 'right' : 'center';
					if (info.footerProps) {
						$fc.addClass(`table_header_${align}`).addClass($.dashedCase(info.footer)).attr('data-ref', JSON.stringify(info.footerProps)).append('<span class="table_cell_content"></span>');
					} else {
						$fc.addClass(`table_header_${align}`).addClass($.dashedCase(info.footer)).attr('data-ref', info.footer).append('<span class="table_cell_content"></span>');
					}
					if (info.footerOptions) {
						$fc.attr('data-options', JSON.stringify(info.footerOptions));
					}
				}

				let appendCell = true;
				if (info.footerOptions && info.footerOptions.colspan) {
					$fc.attr('colspan', info.footerOptions.colspan);
					colspanBuffer = info.footerOptions.colspan - 1;
				} else if (colspanBuffer > 0) {
					appendCell = false;
					colspanBuffer = colspanBuffer - 1;
				}
				if (appendCell) {
					$footerRow.append($fc);
				}
			});
	},
	createRadioColumn: function(options) {
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var row = {
			mData: 'id',
			bSortable: false,
			sClass: this._columnsClass('center'),
			mRender: function(data, type, full) {
				return hrd.datatable.createIdCellContent(prefix, full.id);
			},
			fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
				if (!options.visible) {
					$(nTd).hide();
				}
				$('input', nTd).data('info', options);
			}
		};
		return $.extend(row, options);
	},
	createCheckboxColumn: function(options) {
		let ref = this.settings.reference;
		var prefix = this.settings.rowPrefix;
		options = options || {};
		let mData = !options.isGeneric ? 'id' : options.prop;
		let classes = `center ${!options.isGeneric ? 'with-icon' : ''}`;
		var row = {
			mData: mData,
			bSortable: false,
			sClass: this._columnsClass(classes),
			mRender: function(data, type, full) {
				if (!options.isGeneric) {
					return hrd.datatable.createCheckboxCellContent(prefix, full.id);
				} else {
					return hrd.datatable.createGenericCheckboxCellContent(prefix, full.id, data, options.prop);
				}
			},
			fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
				const $input = $('input', nTd);
				if (options.visible === false) {
					$(nTd).hide();
				}
				if (options.selectedProp != undefined) {
					let checked = !!oData[options.selectedProp];
					$input.prop('checked', checked);
				}
				if (!options.isGeneric) {
					$input.data('info', options);
				} else {
					let value = $.isTrue(oData[options.prop]);
					$input.prop('checked', value);
					let events = options.events ? options.events.split(' ') : [];
					events.forEach(ev => {
						let fnName = $.functionCase(`${options.prop}-on-${ev}`);
						let fn = options[fnName];
						if (fn) {
							$input.off(`${ev}.cbt`).on(`${ev}.cbt`, (event) => {
								let isChecked = $input.prop('checked');
								fn.call(ref, event, $input, isChecked, nTd, oData, iRow, iCol);
							});
						}
					});
				}
			}
		};
		return $.extend(row, options);
	},
	createLabelColumn: function(property, options) {
		var prefix = this.settings.rowPrefix;
		var reference = this.settings.reference;
		options = options || {};
		var row = {
			mData: property,
			sDefaultContent: '',
			sClass: this._columnsClass(options.align, options.tdClass)
		};
		if (options.decorator != undefined) {
			if (typeof options.decorator === 'function') {
				options.decorator = options.decorator.bind(reference);
				row.fnCreatedCell = function(nTd, sData, oData, iRow, iCol) {
					options.decorator(property, nTd, sData, oData, iRow, iCol);
				};
			} else if (options.decorator == true) {
				var decoratorFn = $.functionCase(property + '-cell-decorator');
				if (typeof reference[decoratorFn] == 'function') {
					row.fnCreatedCell = function(nTd, sData, oData, iRow, iCol) {
						reference[decoratorFn].call(reference, property, nTd, sData, oData, iRow, iCol);
					};
				} else {
					console.log(`Add method "${decoratorFn}: function(property, nTd, sData, oData, iRow, iCol) {}," for decorating cell "${property}" in "${reference._FULL_}"`);
				}
			}
		}
		if (options.editable != undefined) {
			options.marker = options.marker == undefined ? 'dyna-edit' : options.marker + ' dyna-edit';
		}
		if (options.marker != undefined) {
			row.mRender = function(data, type, full) {
				var ref = options.ref == undefined ? undefined : full[options.ref];
				return hrd.datatable.createCellContentWithMarker.call(reference, prefix, full.id, data, options.marker, options.formatStyle, ref, options);
			};
		} else {
			row.mRender = function(data, type, full) {
				var ref = options.ref == undefined ? undefined : full[options.ref];
				return hrd.datatable.createCellContent.call(reference, prefix, full.id, data, options.formatStyle, ref, options);
			};
		}

		row = $.extend(row, options);

		/* other options */
		if (options.minWidth != undefined) {
			let prevFn = row.fnCreatedCell;
			row.fnCreatedCell = function(nTd, sData, oData, iRow, iCol) {
				let oSettings = this.fnSettings(); // this here is the table. do not use bind or arrow function
				let nTh = $(oSettings.aoColumns[iCol].nTh);
				$(nTh).css('minWidth', options.minWidth);
				if (typeof prevFn === 'function') {
					prevFn(nTd, sData, oData, iRow, iCol);
				}
			};
		}

		return row;
	},
	createButtonColumn: function(actionName, options) {
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var tdClass = 'without-ellipsis' + (options.showHeader ? '' : ' with-icon') + (options.tdClass ? ' ' + options.tdClass : '');
		var row = {
			mData: options.mData || 'id',
			sName: actionName,
			bSortable: false,
			sClass: this._columnsClass('center', tdClass),
			mRender: function(data, type, full) {
				return hrd.datatable.createButtonCellContent(prefix, full.id, actionName, options);
			}
		};
		/* if custom 'fnCreatedCell' is not available, a generic common way is used.*/
		if (options.fnCreatedCell === undefined) {
			var reference = this.settings.reference;
			row.fnCreatedCell = function(nTd, sData, oData, iRow, iCol) {
				var $table = this;
				var $btn = $('button', nTd);
				var iconOptions;
				var btnOptionsFn = $.functionCase(actionName + '-button-options');
				if (typeof reference[btnOptionsFn] == 'function') {
					iconOptions = reference[btnOptionsFn].call(reference, oData, $btn) || {};
				} else {
					if (!options.iconOpts) {
						console.log(`Add method "${btnOptionsFn}: function(rowData, $btn) {}," for assigning icon options for "${actionName}" column to "${reference._FULL_}"`);
					}
					iconOptions = options.iconOpts || {};
				}

				var hasRowClick = (typeof reference.clickRow == 'function'); // needed to force stop propagation

				$(nTd).addClass('no-focus');
				$btn.button({
					icons: {
						primary: "f-icon " + iconOptions.icon
					},
					disabled: iconOptions.disabled,
					text: false
				})
					.attr('title', iconOptions.tooltip)
					.off('click.table-button')
					.on('click.table-button', function(event) {
						// disablig button til response
						$btn.button('disable').waiting();
						var $tr = $btn.closest('tr');
						var currentId = hrd.datatable.getIdByRow($tr);
						var currentSelectedId = hrd.datatable.getSelectedRowId($table);
						let actionResponse;
						if (options.callback) {
							actionResponse = options.callback.call(reference, event, $btn, oData, iRow, iCol);
						} else {
							var fnAction = $.functionCase(actionName + 'Action');
							if (typeof reference[fnAction] === 'function') {
								actionResponse = reference[fnAction].call(reference, event, $btn, oData, iRow, iCol);
							} else {
								console.log(`Add method "${fnAction}: function(event, $btn, oData, iRow, iCol) {}," for assigning action for "${actionName}" column to "${reference._FULL_}"`);
							}
						}
						if (hasRowClick || options.stopPropagation || (currentId == currentSelectedId && currentId != -1)) {
							event.stopPropagation();
						}
						// reenabling the button, if not requested otherwise
						if (!options.ignoreActivateOnReturn) {
							$.when(actionResponse).always(() => {
								$btn.button('enable').waiting('done');
							});
						}
					});
				if (iconOptions.btnClass != undefined) {
					$btn.addClass(iconOptions.btnClass);
				}
				if (iconOptions.hide === true) {
					$btn.hide();
				}
			};
		}
		return $.extend(row, options);
	},
	createIconColumn: function(iconName, options) {
		let toolbox = new hrd.Toolbox();
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var tdClass = 'without-ellipsis' + (options.showHeader ? '' : ' with-icon');
		var row = {
			mData: options.mData || 'id',
			sName: iconName,
			bSortable: false,
			sClass: this._columnsClass('center', tdClass),
			mRender: function(data, type, full) {
				var iconOptions;
				let sFnIconOptions = $.functionCase(`${iconName}-icon-options`);
				if (typeof this[sFnIconOptions] == 'function') {
					let iconValue = toolbox.get(iconName, full);
					iconOptions = this[sFnIconOptions].call(this, iconValue, full);
				} else {
					if (!options.iconOpts) {
						console.log(`Add method "${sFnIconOptions}: function(iconValue, oData) {}," for assigning icon options for ${iconName} column to "${this._FULL_}"`);
					}
					iconOptions = options.iconOpts || {};
				}
				return hrd.datatable.createIconCellContent(prefix, full.id, iconName, iconOptions);
			}.bind(this.settings.reference),
			fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
				var iconOptions;
				let sFnIconOptions = $.functionCase(`${iconName}-icon-options`);
				if (typeof this[sFnIconOptions] == 'function') {
					let iconValue = toolbox.get(iconName, oData);
					iconOptions = this[sFnIconOptions].call(this, iconValue, oData);
				} else {
					iconOptions = options.iconOpts || {};
				}
				$icon = $('span.table-cell-icon', nTd);
				let tooltipOptions = {};
				if (iconOptions.tooltipClass != undefined) {
					tooltipOptions.tooltipClass = iconOptions.tooltipClass;
				}
				if (iconOptions.tooltipPosition != undefined) {
					tooltipOptions.position = iconOptions.tooltipPosition;
				}
				if (iconOptions.tooltipEncoded != undefined) {
					tooltipOptions.content = toolbox.atou($icon.attr('title'));
				}
				if (iconOptions.tooltipKeepItOpened === true) {
					tooltipOptions.open = function(event, ui) {
						if (typeof (event.originalEvent) === 'undefined') {
							return false;
						}
						var $id = $(ui.tooltip).attr('id');
						// close any lingering tooltips
						$('div.ui-tooltip').not('#' + $id).remove();
					};
					tooltipOptions.close = function(event, ui) {
						let over = function() { $(this).stop(true).fadeTo(400, 1); };
						let out = function() { $(this).fadeOut('400', function() { $(this).remove(); }); };
						ui.tooltip.hover(over, out);
					};
				}
				if (iconOptions.action === true) {
					var sActionFn = $.functionCase(iconName + '-icon-action');
					if (typeof this[sActionFn] === 'function') {
						$icon.on('click.iconAction', _ => {
							this[sActionFn].call(this, nTd, sData, oData, iRow, iCol);
						});
					} else {
						console.log(`Add method "${sActionFn}: function(nTd, sData, oData, iRow, iCol) {}," for assigning icon action for "${iconName}" column to "${this._FULL_}"`);
					}
				}

				$icon.tooltip(tooltipOptions);

				if (iconOptions.hide === true) {
					$icon.hide();
				}
				if(typeof options.fnCustomCreatedCell === 'function') {
					options.fnCustomCreatedCell.call(this, nTd, sData, oData, iRow, iCol);
				}
			}.bind(this.settings.reference)
		};
		return $.extend(row, options);
	},
	createBooleanIconColumn: function(iconName, options) {
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var tdClass = 'without-ellipsis' + (options.showHeader ? '' : ' with-icon');
		var row = {
			mData: 'id',
			sName: iconName,
			bSortable: false,
			sClass: this._columnsClass('center', tdClass),
			mRender: function(data, type, full) {
				var tooltip = '';
				if (typeof options.tooltip == 'function') {
					tooltip = options.tooltip.call(this.settings.reference, full);
				} else {
					tooltip = options.tooltip || '';
				}
				var iconOptions = {
					icon: $.isTrue(full[iconName]) ? 'f-icon far fa-check-square' : 'f-icon far fa-square',
					tooltip: tooltip,
					color: $.isTrue(full[iconName]) ? 'green' : 'red'
				};
				return hrd.datatable.createIconCellContent(prefix, full.id, iconName, iconOptions);
			}.bind(this),
			fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
				$('span.table-cell-icon', nTd).tooltip();
			}
		};
		this._checkOptions(options);
		return $.extend(row, options);
	},
	createEmtpyColumn: function(options) {
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var row = {
			mData: 'id',
			bSortable: false,
			sClass: this._columnsClass('center'),
			mRender: function(data, type, full) {
				return hrd.datatable.createEmptyCellContent(prefix, full.id, data);
			},
		};
		if(options.sName != undefined) {
			row.sName = options.sName;
		}
		this._checkOptions(options);
		return $.extend(row, options);
	},
	createScrollbarPlaceholderColumn: function(options) {
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var row = {
			mData: 'id',
			bSortable: false,
			sClass: this._columnsClass('center', 'scrollbar-cell'),
			mRender: function(data, type, full) {
				return hrd.datatable.createEmptyCellContent(prefix, full.id, data);
			},
			fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
				$(nTd).addClass('no-focus');
			}
		};
		if(options.sName != undefined) {
			row.sName = options.sName;
		}
		this._checkOptions(options);
		return $.extend(row, options);
	},
	createColoredColumn: function(property, options) {
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var tdClass = 'without-ellipsis' + (options.showHeader ? '' : ' with-icon');
		var row = {
			mData: property,
			bSortable: false,
			sClass: this._columnsClass('center', tdClass),
			mRender: function(data, type, full) {
				return hrd.datatable.createColoredCellContent(prefix, full.id, data, options);
			}
		};
		this._checkOptions(options);
		return $.extend(row, options);
	},
	createImageColumn: function(property, options) {
		options = options || {};
		var kr = (options.keepRatio == undefined || options.keepRatio) ? 'F' : '0';
		options.width = parseInt(options.width || '40');
		options.height = parseInt(options.height || '40');
		var w = hrd.Form.prototype.utils().leftPad(options.width.toString(16), 3, '0');
		var h = hrd.Form.prototype.utils().leftPad(options.height.toString(16), 3, '0');
		var th = kr + w + h;
		options.th = th;
		options.marker = options.marker || '';
		var prefix = this.settings.rowPrefix;
		var tdClass = 'without-ellipsis' + (options.tdClass ? ' ' + options.tdClass : '');
		var row = {
			mData: property,
			bSortable: false,
			sClass: this._columnsClass('center', tdClass),
			mRender: function(data, type, full) {
				options.uid = full[property] != undefined ? full[property].uid : undefined;
				return hrd.datatable.createImageCellContent(prefix, full, options);
			}
		};
		this._checkOptions(options);
		return $.extend(row, options);
	},
	createFileColumn: function(property, options) {
		options = $.extend({}, {
			stopPropagation: true,
			marker: '',
		}, options);
		var actionName = property;
		var reference = this.settings.reference;
		var prefix = this.settings.rowPrefix;
		var tdClass = 'without-ellipsis with-icon' + (options.tdClass ? ' ' + options.tdClass : '');
		var row = {
			mData: property,
			bSortable: false,
			sClass: this._columnsClass('center', tdClass),
			mRender: function(data, type, full) {
				let filePresent = hrd.utils.isNotEmpty(full[property]);
				return hrd.datatable.createFileCellContent(prefix, full, filePresent, options);
			}
		};
		row.fnCreatedCell = function(nTd, sData, oData, iRow, iCol) {
			var $table = this;
			var $btn = $('button', nTd);
			let filePresent = hrd.utils.isNotEmpty(oData[property]);

			options.iconOpts = $.extend({}, {
				icon: 'fas fa-paperclip', // renderlo dinamico in base al content type?
				tooltip: xlate('common.attachment.file.download.title'),
			}, options.iconOpts);

			if (filePresent) {
				$(nTd).addClass('no-focus');
			}
			$btn.button({
				icons: {
					primary: "f-icon " + options.iconOpts.icon
				},
				disabled: !!options.iconOpts.disabled,
				text: false
			})
				.attr('title', options.iconOpts.tooltip)
				.off('click.table-button')
				.on('click.table-button', function(event) {
					let toDownloadUri = `${hrd.fn.actionURI('download')}?uid=${oData[property].uid}`;
					window.open(toDownloadUri, '_blank');
					if (options.stopPropagation) {
						event.stopPropagation();
					}
				});
		};
		return $.extend(row, options);
	},
	createInputColumn: function(selectName, options) {
		throw 'createInputColumn is not yet implemented';
	},
	createSelectColumn: function(selectName, options) {
		var prefix = this.settings.rowPrefix;
		options = options || {};
		var row = {
			mData: 'id',
			sName: selectName,
			bSortable: false,
			sClass: this._columnsClass('left', options.tdClass),
			mRender: function(data, type, full) {
				return hrd.datatable.createSelectCellContent(prefix, full.id, selectName, options);
			}.bind(this.settings.reference),
			fnCreatedCell: function(nTd, sData, oData, iRow, iCol) {
				var $select = $('select', nTd);
				$select.attr('data-provider', options.provider);
				$select.attr('data-provider-extra-args', options.providerExtraArgs);
				$select.attr('data-label-property', options.labelProperty);
				// todo: understand how to behave if form not present....
				this.formInstance.enhanceEditField($select); // just to view correctly the select.
				$select.on('change.sc', (evt) => {
					oData[selectName] = $select.val();
				});
			}.bind(this.settings.reference)
		};
		return $.extend(row, options);
	},
	createCustomColumn: function(options) {
		let prefix = this.settings.rowPrefix;
		options = options || {};
		let marker = options.marker || '';
		// all custom template avoid auto-ellipsis
		let tdClass = 'without-ellipsis' + (options.tdClass ? ' ' + options.tdClass : '');
		let align = options.align || 'left';
		let row = {
			mData: options.prop || "id",
			sName: options.name || 'custom',
			bSortable: false,
			sClass: this._columnsClass(align, tdClass),
			mRender: function(data, type, full) {
				var template = '';
				if (typeof options.template == 'function') {
					template = options.template.call(this, full);
				} else if (typeof this[options.name] == 'function') {
					template = this[options.name].call(this, full);
				} else {
					if (options.name == undefined) {
						console.log('Add option "name" to column info for defining custom template');
					} else {
						console.log('Add method "' + options.name + '" for defining custom template');
					}
				}
				return hrd.datatable.createCustomCellContent(prefix, template, full, marker, options);
			}.bind(this.settings.reference)
		};
		this._checkOptions(options);
		return $.extend(row, options);
	},
	_checkOptions: function(options) {
		/* check if fnCreatedCell is defined and if it is available in proper scope */
		if (options.hasOwnProperty('fnCreatedCell')) {
			if (typeof options.fnCreatedCell === 'function') {
				options.fnCreatedCell = options.fnCreatedCell.bind(this.settings.reference); // bound to table dashlet for easier usage
			} else if (typeof options.fnCreatedCell === 'string') {
				// should be a function name available in 'reference' object
				let fn;
				try {
					fn = eval(`this.settings.reference.${options.fnCreatedCell}`);
				} catch (e) {
				}
				if (typeof fn === 'function') {
					options.fnCreatedCell = fn;
				} else {
					console.log(`Warning: the "fnCreatedCell" attribute is defined using a missing function "${options.fnCreatedCell}". Please check and fix it`, options);
					options.fnCreatedCell = undefined;
				}
			} else {
				console.log('Warning: the "fnCreatedCell" attribute is defined using a missing function. Please check and fix it', options);
			}
		}
	},
	_columnsClass: function(align, extraClass) {
		align = align || 'left';
		return "table-cell-natural table_cell_data ui-widget-content table_cell_" + align + ((extraClass != undefined) ? " " + extraClass : "");
	},
	updateIconCell: function(nTd, options) {
		options = options || {};
		let $nTd = $(nTd);
		let $icon = $nTd.find('.table-cell-icon');
		if(options.hasOwnProperty('icon')) {
			if(options.icon) {
				$icon.removeClass().addClass(`table-cell-icon f-icon ${options.icon}`);
			} else {
				$icon.removeClass().addClass(`table-cell-icon f-icon fas fa-none`);
			}
		}
		
		if(options.hasOwnProperty('color')) {
			if(options.color) {
				$icon.css('color', options.color);
			} else {
				$icon.css('color', '');
			}
		}
		
		if(options.hasOwnProperty('tooltip')) {
			if(options.tooltip) {
				$icon.attr('title', options.tooltip);
			} else {
				$icon.removeAttr('title');
			}
		}
	},
	refreshTable: function(options) {
		options = options || {};
		let settings = $.extend({}, {
			samePage: false,
			naturalSorting: true,
			useCache: false
		}, options);
		if (this.tableInstance) {
			let oSettings = this.tableInstance.fnSettings();
			oSettings.useCache = settings.useCache;
			let promise = (settings.samePage) ? this.tableInstance.fnStandingRedraw() : (settings.naturalSorting) ? this.tableInstance.fnSortNeutral() : this.tableInstance.fnAsynchDraw();
			if(oSettings.ignoreFirstCall) {
				promise = $.timeout(0).then(() => this.refreshTable(options));
			}
			return promise;
		} else {
			return $.when();
		}
	},
	exportExcel: function(options) {
		let tableInfo = this.getTableInfo();
		options = $.extend({}, tableInfo.export, options);
		let exporter = new hrd.utils.export.ExcelExporter(this, options);
		return exporter.export();
	},
	exportCSV: function(options) {
		let tableInfo = this.getTableInfo();
		options = $.extend({}, tableInfo.export, options);
		let exporter = new hrd.utils.export.CSVExporter(this, options);
		return exporter.export();
	},
	rowFocus: function(rowId) {
		$nRow = this.getRowById(rowId);
		if ($nRow.exists()) {
			hrd.datatable.addRowClass($nRow, 'ui-state-focus');
		}
	},
	rowBlur: function(rowId) {
		$nRow = this.getRowById(rowId);
		if ($nRow.exists()) {
			hrd.datatable.removeRowClass($nRow, 'ui-state-focus');
		}
	},
	getActiveRowId: function() {
		return hrd.datatable.getActiveRowId(this.settings.tableId);
	},
	getActiveRow: function() {
		var id = this.getActiveRowId();
		return this.getRowById(id);
	},
	getActiveRowData: function() {
		var $row = this.getActiveRow();
		if ($row.exists()) {
			var oSettings = this.tableInstance.fnSettings();
			var index = $row.data('row-index');
			var rowData = this.tableInstance.fnGetData(index - oSettings._iDisplayStart);
			return rowData;
		} else {
			return undefined;
		}
	},
	makeRowActive: function(rowId) {
		hrd.datatable.makeRowActive(this.settings.tableId, rowId);
	},
	clearRowActive: function() {
		hrd.datatable.clearRowActive(this.settings.tableId);
	},
	/**
	 * Useful for select active row programmatically
	 */
	activateActiveRow: function() {
		hrd.datatable.activateActiveRow(this.tableInstance.fnSettings());
	},
	/**
	 * Useful for un-select active row programmatically
	 */
	deactivateActiveRow: function() {
		hrd.datatable.deactivateActiveRow(this.tableInstance.fnSettings());
	},
	onSelectionChange: function(nRow, aData, iDisplayIndex, iDisplayIndexFull, checked, value, event) {
		let sFnChangeRow = $.functionCase(`change-row`);
		let fnChangeRow = this.settings.reference[sFnChangeRow];
		let tableName = this.container.data('name');
		if (tableName != undefined) {
			sFnChangeRow = $.functionCase(`${tableName}-change-row`);
			if (typeof this.settings.reference[sFnChangeRow] === 'function') {
				fnChangeRow = this.settings.reference[sFnChangeRow];
			} else {
				console.info(`It is possible to use "${sFnChangeRow}" in place of "changeRow" as method to specify additional parameters in ${this.settings.reference._FULL_}`);
			}
		}
		if (typeof fnChangeRow === 'function') {
			var originalArgs = {
				nRow: nRow,
				aData: aData,
				iDisplayIndex: iDisplayIndex,
				iDisplayIndexFull: iDisplayIndexFull
			}
			fnChangeRow.call(this.settings.reference, checked, value, { indexes: this.getSelectedIndexes() }, originalArgs, event);
		} else {
			console.log(`For a complete management you can add "changeRow" method to "${this.settings.reference._FULL_}"`);
		}
	},
	onToggleAll: function(checked) {
		var tableData = this.tableInstance.fnGetData(); // only the visible part!!!!
		if (checked) {
			$.each(tableData, (i, row) => {
				this.addSelection(row.id, row, true);
			});
		} else {
			// reset data before applying 'toggle', re-adding all available elements
			this.emptySelectedInfo();
		}
		$('input[type="checkbox"]', this.tableInstance).prop('checked', checked);
		this.updateToggleAllElement();

		let sFnToggleAll = $.functionCase(`toggle-all`);
		let fnToggleAll = this.settings.reference[sFnToggleAll];
		let tableName = this.container.data('name');
		if (tableName != undefined) {
			sFnToggleAll = $.functionCase(`${tableName}-toggle-all`);
			if (typeof this.settings.reference[sFnToggleAll] === 'function') {
				fnToggleAll = this.settings.reference[sFnToggleAll];
			} else {
				console.info(`It is possible to use "${sFnToggleAll}" in place of "toggleAll" as method to specify additional parameters in ${this.settings.reference._FULL_}`);
			}
		}
		if (typeof fnToggleAll === 'function') {
			fnToggleAll.call(this.settings.reference, checked, { indexes: this.getSelectedIndexes() });
		} else {
			console.log(`For a complete management you can add "toggleAll" method to "${this.settings.reference._FULL_}"`);
		}
	},
	toggleRow: function(nRow, checked) {
		$('input[type="checkbox"]', nRow).prop('checked', checked);
	},
	/**
	 * Add if not present
	 */
	addSelection: function(rowId, rowData, skipUpdateToggleAll) {
		var index = this.selectedIndexes.indexOf(rowId);
		if (index == -1) {
			this.selectedIndexes.push(rowId);
			this.selectedObjects[rowId] = this._adaptObject(rowId, rowData);
			this.updateToggleAllElement(skipUpdateToggleAll);
		}
	},
	/**
	 * Remove if present
	 */
	removeSelection: function(rowId) {
		var index = this.selectedIndexes.indexOf(rowId);
		if (index !== -1) {
			this.selectedIndexes.splice(index, 1);
			delete this.selectedObjects[rowId];
			this.updateToggleAllElement();
			// remove 'checked' flag from checkbox
			$('input[type="checkbox"][value="' + rowId + '"]', this.settings.tableId).prop('checked', false);
		}
	},
	updateToggleAllElement: function(skipUpdateToggleAll) {
		skipUpdateToggleAll = !!skipUpdateToggleAll;
		if (!skipUpdateToggleAll && this.$toggleAllElement != undefined && this.tableInstance) {
			var oSettings = this.tableInstance.fnSettings();
			let effectiveSelectedSize = this.effectiveSelectedSize();
			if (effectiveSelectedSize === 0) {
				this.$toggleAllElement.prop("checked", false);
				this.$toggleAllElement.prop("indeterminate", false).attr("indeterminate", null);
			} else if (effectiveSelectedSize === oSettings._iRecordsTotal) {
				this.$toggleAllElement.prop("checked", true);
				this.$toggleAllElement.prop("indeterminate", false).attr("indeterminate", null);
			} else {
				this.$toggleAllElement.prop("checked", false);
				this.$toggleAllElement.prop("indeterminate", true).attr("indeterminate", true);
			}
		}
	},
	getTotalRecords: function() {
		let oSettings = this.tableInstance.fnSettings();
		return oSettings._iRecordsTotal;
	},
	/* this method can be overridden by implementors in order to decide which is the effective selection size */
	effectiveSelectedSize: function() {
		return this.selectedIndexes.length;
	},
	/* this method can be overridden by implementors in order to decide which selections must be reoved and which ones can be kept */
	emptySelectedInfo: function() {
		this.selectedIndexes = [];
		this.selectedObjects = {};
	},
	_adaptObject: function(rowId, rowData) {
		let fnAdapter = this.__toFn__('row-data-adapter', !(typeof this.settings.reference['rowDataAdapter'] === 'function'));

		var adapter = (typeof fnAdapter === 'function') ? fnAdapter : (() => rowId);
		return adapter.call(this.settings.reference, rowData);
	},
	__toFn__: function(sFnName, ignoreLogging) {
		ignoreLogging = !!ignoreLogging;
		let sFnOrig = $.functionCase(`${sFnName}`);
		let sFn = $.functionCase(`${sFnName}`);
		let fn = this.settings.reference[sFn];
		let tableName = this.container.data('name');
		if (tableName != undefined) {
			sFn = $.functionCase(`${tableName}-${sFnName}`);
			if (typeof this.settings.reference[sFn] === 'function') {
				fn = this.settings.reference[sFn];
			} else {
				if (!ignoreLogging) {
					console.info(`It is possible to use "${sFn}" in place of "${sFnOrig}" as table-name specific method in "${this.settings.reference._FULL_}"`);
				}
			}
		}
		return fn;
	},
	getSelectedRowData: function() {
		var $row = this.getSelectedRow();
		if ($row.exists()) {
			var oSettings = this.tableInstance.fnSettings();
			var index = $row.data('row-index');
			var rowData = this.tableInstance.fnGetData(index - oSettings._iDisplayStart);
			return rowData;
		} else {
			return undefined;
		}
	},
	/**
	 * Utile per avere oggetto riga ($tr) selezionata di tabella a selezione singola
	 */
	getSelectedRow: function() {
		var $row = $('input:radio:checked', this.settings.tableId).closest('tr');
		return $row;
	},
	getFirstRow: function() {
		var $row = $('input:radio, input:checkbox', this.settings.tableId).first().closest('tr');
		return $row;
	},
	getFirstRowByPropertyValue: function(property, value) {
		let rowId = undefined;
		if (this.tableInstance != undefined) {
			let nodes = this.tableInstance.fnGetData();
			let rowData = nodes.find(n => n[property] == value);
			rowId = (rowData != undefined) ? rowData.id : undefined;
		}
		return this.getRowById(rowId);
	},
	getFirstRowIndexByPropertyValue: function(property, value) {
		let rowId = undefined;
		if (this.tableInstance != undefined) {
			let nodes = this.tableInstance.fnGetData();
			let rowData = nodes.find(n => n[property] == value);
			rowId = (rowData != undefined) ? rowData.id : undefined;
		}
		return this.getRowIndexById(rowId);
	},
	/**
	 * Utile per avere oggetto riga ($tr) selezionata di tabella a selezione singola dato id riga
	 */
	getRowById: function(rowId) {
		var $row;
		if (rowId == undefined) {
			$row = $('.non-existent-element'); // a valid jquery element, but really not present in page
		} else {
			$row = $('input[type="radio"][value="' + rowId + '"]', this.settings.tableId).closest('tr');
			if (!$row.exists()) {
				$row = $('input[type="checkbox"][value="' + rowId + '"]', this.settings.tableId).closest('tr');
			}
		}
		return $row;
	},
	/**
	 * Utile per avere indice di una riga noto il suo id. Torna -1 se non trovato
	 */
	getRowIndexById: function(rowId) {
		var $row;
		var index = -1;
		if (rowId != undefined) {
			$row = $('tr[id="' + rowId + '"]', this.settings.tableId);
			if ($row.exists()) {
				index = $row.data('row-index');
			}
		}
		return index;
	},
	selectTableRowById: function(rowId, applyIgnoreCallback) {
		var $row = this.getRowById(rowId);
		return this.selectTableRow($row, applyIgnoreCallback)
	},
	selectTableRow: function($row, ignoreCallback) {
		if ($row.exists()) {
			ignoreCallback = (ignoreCallback == undefined) ? false : ignoreCallback;
			this.makeRowVisible($row);
			if (ignoreCallback) {
				$row.data('ignore-callback', true);
			} else {
				$row.data('force-click', true);
			}
			$row.trigger('click', $row);
		}
	},
	makeRowVisible: function($row) {
		if ($row.exists()) {
			var oSettings = this.fnSettings();
			if (oSettings && oSettings.oScroller && oSettings.oScroller.fnScrollToRow) {
				var vis = $row.visibleInScroll(false);
				if (!vis.isVisible || !vis.isContained) {
					oSettings.oScroller.fnScrollToRow($row.data('row-index'));
				}
			}
		}
	},
	makeRowVisibleById: function(rowId) {
		$row = this.getRowById(rowId);
		this.makeRowVisible($row);
	},
	/**
	 * Select all the rows with given id, checking the correspondent check-box.
	 * All the other will be unselect
	 * Useful for multi-selection tables (with check-box)
	 */
	selectTableRows: function(rowIds, trigger) {
		if (rowIds && rowIds.length > 0) {
			$('input:checkbox', this.settings.tableId).each((i, row) => {
				var $row = $(row);
				var currentRowValue = $row.val();
				var found = rowIds.find(value => currentRowValue == value);

				if (trigger) {
					if (found) {
						$row.trigger(trigger, $row);
					}
				} else {
					$row.prop('checked', found !== undefined);
				}
			});
		}
	},
	/**
	 * Data un id di colonna (cioè il campo usato per referenziarla) restituisce indice di posizionamento della colonna stessa
	 * Si può usare anche il valore dell'attributo 'sName' invece che 'mData', per recuperare colonne con bottone
	 */
	getColumnIndexById: function(colName) {
		var index = -1;
		if (this.tableInstance != undefined) {
			var oSettings = this.tableInstance.fnSettings();
			$.each(oSettings.aoColumns, function(i, val) {
				if (val.sName == colName || val.mData == colName) {
					index = i;
				}
			});
		}
		return index;
	},
	hasSelectedItems: function() {
		if (this.settings.isMultiSelectTable) {
			let size = this.effectiveSelectedSize();
			return size > 0;
		} else {
			let selectedRow = this.getSelectedRow();
			return selectedRow.exists();
		}
	},
	/**
	 * Return array of selected row 'ids', but only the visible 'page'
	 */
	getSelectedIndexes: function() {
		return this.selectedIndexes;
	},
	/**
	 * Return array of selected row objects, but only the visible 'page'
	 */
	getSelectedData: function() {
		return Object.values(this.selectedObjects);
	},
	/**
	 * Visually remove the flag in the selected chekboxes. Moreover reset the internal variable used for caching the values
	 */
	clearSelectedIndexes: function() {
		this.selectedIndexes = [];
		this.selectedObjects = {};
		var wrapper = $(this.settings.tableId).closest('.dataTables_wrapper');
		$('input[type="checkbox"]:checked, input[type="checkbox"]:indeterminate', wrapper).each(function(index, input) {
			$(input).prop('checked', false);
			$(input).prop("indeterminate", false);
		});
		this.updateToggleAllElement();
	},
	/**
	 * Method that will filter the table programmatically
	 *
	 */
	filter: function(filterText) {
		this.tableInstance.fnFilter(filterText);
	},
	/**
	 * Method that will clear the filter table field
	 *
	 */
	clearFilters: function(redraw) {
		this.tableInstance.fnFilterClear(true, redraw);
	},
	clearTable: function(redraw) {
		let oSettings = this.tableInstance.fnSettings();
		oSettings.jCachedData = undefined;
		this.tableInstance.fnClearTable(false);
		$('tbody', this.tableInstance).empty();
	},
	toggleColumnVisibility: function(colName, visible, redraw) {
		if (this.tableInstance) {
			var iCol = this.getColumnIndexById(colName);
			var column = this.tableInstance.fnSettings().aoColumns[iCol];
			if (column) {
				if (visible == undefined) {
					visible = column.bVisible;
				}
				this.tableInstance.fnSetColumnVis(iCol, visible, redraw);
			} else {
				console.log('Column "' + colName + '" not available in the table "' + this.settings.tableId + '"');
			}
		} else {
			// table instance not yet available... use direct method
			hrd.datatable.toggleColumnVisibility(this.settings.tableId, colName, visible, redraw);
		}
	},
	/**
	 * Facility for colouring the background of a row with a given colour.
	 * Moreover the foreground colour will be computed in order to make it visible on that background
	 * @param nRow
	 * @param backgroundColor
	 */
	colorizeRow: function(nRow, bgColor, markerClass) {
		markerClass = markerClass || 'custom-color';
		var fgColor = $.colorHelper().computeTextColor(bgColor);
		var focusColor = $.colorHelper().darken(bgColor, 15);
		var fgFocusColor = $.colorHelper().computeTextColor(focusColor);
		var normalStyle = { backgroundColor: bgColor, color: fgColor, borderColor: bgColor };
		var focusStyle = { backgroundColor: focusColor, color: fgFocusColor, borderColor: focusColor };
		var $nRow = $(nRow);
		$nRow.addClass(markerClass);
		$('td:not(.no-focus)', nRow).each((i, cell) => {
			$(cell).addClass('custom-color').css(normalStyle);
		});
		$nRow.off('.cr')
			.on('mouseover.cr', (evt) => {
				$('td:not(.no-focus)', evt.currentTarget).each((i, cell) => {
					$(cell).css(focusStyle);
				});
			})
			.on('mouseout.cr', (evt) => {
				$('td:not(.no-focus)', evt.currentTarget).each((i, cell) => {
					$(cell).css(normalStyle);
				});
			});
	},
	unColorize: function(markerClass) {
		markerClass = markerClass || 'custom-color';
		var normalStyle = { backgroundColor: '', color: '', borderColor: '' };
		$('tr.' + markerClass, this.settings.tableId).each((i, nRow) => {
			$('td:not(.no-focus)', nRow).each((i, cell) => {
				$(cell).removeClass('custom-color').css(normalStyle);
			});
			$(nRow).off('.cr').removeClass(markerClass);
		});
	},
	/**
	 * METODHS Useful for RecordSet Navigator
	 */
	currentRowData: function(index, property = 'id', tentative = 1) {
		const oSettings = this.tableInstance.fnSettings();
		let rowIndex = index - 1;
		let iDisplayStart = oSettings._iDisplayStart;
		let iRecordsDisplay = oSettings._iRecordsDisplay;
		let normalizedIndex = rowIndex - iDisplayStart;
		let row = this.tableInstance.fnGetData(normalizedIndex);
		let rowId = this.__extract__(property, row);
		let output = { index: index, size: iRecordsDisplay, isFirst: index === 1, isLast: index === iRecordsDisplay };
		return $.when($.extend(output, rowId));
	},
	goToIndex: function(index, property = 'id') {
		const oSettings = this.tableInstance.fnSettings();
		let iDisplayStart = oSettings._iDisplayStart;
		let iDisplayLength = oSettings._iDisplayLength;
		let iRecordsDisplay = oSettings._iRecordsDisplay;

		index = Math.max(1, Math.min(index, iRecordsDisplay)); // lo forzo nel range disponibile
		let rowIndex = index - 1;
		let normalizedIndex = rowIndex - iDisplayStart;

		let isPresentInCurrentView = (normalizedIndex >= 0) && (normalizedIndex < iDisplayLength);
		if (!isPresentInCurrentView) {
			return this.tableInstance.fnPageWithIndexDraw(rowIndex).then(() => this.goToIndex(index, property));
		} else {
			let row = this.tableInstance.fnGetData(normalizedIndex);
			let rowId = this.__extract__(property, row);
			let output = { index: index, size: iRecordsDisplay, isFirst: index === 1, isLast: index === iRecordsDisplay };
			return $.when($.extend(output, rowId));
		}
	},
	firstRowData: function(property = 'id') {
		const oSettings = this.tableInstance.fnSettings();
		let iDisplayStart = oSettings._iDisplayStart;
		let iRecordsDisplay = oSettings._iRecordsDisplay;

		if (iDisplayStart !== 0) {
			return this.tableInstance.fnFirstPageDraw().then(() => this.firstRowData(property));
		} else {
			let firstRow = this.tableInstance.fnGetData(0);
			let firstRowId = this.__extract__(property, firstRow);
			let output = { index: 1, size: iRecordsDisplay, isFirst: true, isLast: iRecordsDisplay === 1 };
			return $.when($.extend(output, firstRowId));
		}
	},
	prevRowData: function(index, property = 'id', tentative = 1) {
		const oSettings = this.tableInstance.fnSettings();
		let rowIndex = index - 1;
		let nextIndex = rowIndex - 1;
		let iDisplayStart = oSettings._iDisplayStart;
		let iRecordsDisplay = oSettings._iRecordsDisplay;

		let normalizedIndex = nextIndex - iDisplayStart;
		let prevRow = this.tableInstance.fnGetData(normalizedIndex);

		if (prevRow == undefined) {
			if (rowIndex === 0 || tentative == 3) {
				return $.when(undefined); // forse meglio un navInfo speciale
			} else {
				return this.tableInstance.fnPrevPageDraw().then(() => this.prevRowData(index, property, ++tentative));
			}
		} else {
			let prevRowId = this.__extract__(property, prevRow);
			let index = nextIndex + 1;
			let output = { index: index, size: iRecordsDisplay, isFirst: index === 1, isLast: index === iRecordsDisplay };
			return $.when($.extend(output, prevRowId));
		}
	},
	nextRowData: function(index, property = 'id', tentative = 1) {
		const oSettings = this.tableInstance.fnSettings();
		let rowIndex = index - 1;
		let nextIndex = rowIndex + 1;
		let iDisplayStart = oSettings._iDisplayStart;
		let iRecordsDisplay = oSettings._iRecordsDisplay;

		let normalizedIndex = nextIndex - iDisplayStart;
		let nextRow = this.tableInstance.fnGetData(normalizedIndex);
		if (nextRow == undefined) {
			if (nextIndex === iRecordsDisplay || tentative == 3) {
				return $.when(undefined); // forse meglio un navInfo speciale
			} else {
				return this.tableInstance.fnNextPageDraw().then(() => this.nextRowData(index, property, ++tentative));
			}
		} else {
			let nextRowId = this.__extract__(property, nextRow);
			let index = nextIndex + 1;
			let output = { index: index, size: iRecordsDisplay, isFirst: index === 1, isLast: index === iRecordsDisplay };
			return $.when($.extend(output, nextRowId));
		}
	},
	lastRowData: function(property = 'id') {
		const oSettings = this.tableInstance.fnSettings();
		let iDisplayStart = oSettings._iDisplayStart;
		let iRecordsDisplay = oSettings._iRecordsDisplay;
		let iDisplayLength = oSettings._iDisplayLength;
		if (iRecordsDisplay - iDisplayStart > iDisplayLength) {
			return this.tableInstance.fnLastPageDraw().then(() => this.lastRowData(property));
		} else {
			let lastIndex = (iRecordsDisplay - iDisplayStart) - 1;
			let lastRow = this.tableInstance.fnGetData(lastIndex);
			let lastRowId = this.__extract__(property, lastRow);
			let output = { index: iRecordsDisplay, size: iRecordsDisplay, isFirst: iRecordsDisplay === 1, isLast: true };
			return $.when($.extend(output, lastRowId));
		}
	},
	__extract__: function(property, row) {
		if ($.isArray(property)) {
			return property.reduce((o, p) => {
				o[p] = this.toolbox.get(p, row);
				return o;
			}, {});
		} else {
			return { id: this.toolbox.get(property, row) };
		}
	},
	/********************************/
});